import { render, staticRenderFns } from "./AccountsReceivable.vue?vue&type=template&id=474c1ac4&scoped=true"
import script from "./AccountsReceivable.vue?vue&type=script&lang=js"
export * from "./AccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./AccountsReceivable.vue?vue&type=style&index=0&id=474c1ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c1ac4",
  null
  
)

export default component.exports